import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from "react-scroll";

function Header () {

    return (
        <Navbar expand="lg" className="bg-body-tertiary" sticky="top" dir='rtl'>
      <Container id='nav'>
      <Link  
            to="nav" 
            spy={true} 
            smooth={true}
            duration={300}
            >
              עמוד הבית
              </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
          <Link 
            to="timeline" 
            spy={true} 
            smooth={true}
            duration={300}
            >
              ציר זמנים
              </Link>
          </Nav>
          <Nav className="me-auto">
          <Link 
            to="rules" 
            spy={true} 
            smooth={true}
            duration={300}
            >
              תקנון הליגה
              </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    )
}

export default Header;